import React, { useMemo, useState } from "react";
import ApiKey from "models/ApiKey";
import { AgGridReact } from "ag-grid-react";
import {
  ColDef,
  SizeColumnsToContentStrategy,
  SizeColumnsToFitGridStrategy,
  SizeColumnsToFitProvidedWidthStrategy,
} from "ag-grid-community";

import styles from "./ApiKeysTable.module.scss";
import { ReactComponent as Delete } from "assets/icons/delete.svg";
import moment from "moment";

interface ApiKeysTableProps {
  data: ApiKey[];
  onDelete: (id: number) => void;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ActionCell = (props: any) => {
  return (
    <div className={styles.customCell}>
      <Delete
        className={styles.deleteButton}
        onClick={() => props.onDelete(props.value)}
      />
    </div>
  );
};

const ApiKeysTable = ({ data, onDelete }: ApiKeysTableProps) => {
  const [colDefs] = useState<ColDef<ApiKey>[]>([
    { field: "name", headerName: "Name" },
    { field: "key_prefix", headerName: "Key Prefix" },
    {
      field: "created_timestamp",
      headerName: "Created Date",
      valueFormatter: (params) =>
        moment(params.value).format("YYYY/MM/DD H:mm:ss"),
    },
    {
      field: "expiration_timestamp",
      headerName: "Expiration Date",
      valueFormatter: (params) =>
        moment(params.value).format("YYYY/MM/DD H:mm:ss"),
    },
    {
      headerName: "Actions",
      cellRenderer: ActionCell,
      width: 100,
      valueGetter: (params) => params.data?.id,
      cellRendererParams: {
        onDelete,
      },
    },
  ]);

  const autoSizeStrategy = useMemo<
    | SizeColumnsToFitGridStrategy
    | SizeColumnsToFitProvidedWidthStrategy
    | SizeColumnsToContentStrategy
  >(() => {
    return {
      type: "fitGridWidth",
    };
  }, []);

  return (
    <AgGridReact
      rowData={data}
      columnDefs={colDefs}
      autoSizeStrategy={autoSizeStrategy}
    />
  );
};

export default ApiKeysTable;
